import $ from 'jquery';
import 'jquery.easing';

const $promoCards = $('.promo-card');

$promoCards.each((i, el) => {
  const $el = $(el);
  const $moreBtn = $el.find('.promo-card-more-btn');
  const $fullDescription = $el.find('.promo-card-full-description');
  let isOpen = false;

  function closeMore() {
    isOpen = false;

    $fullDescription.animate(
      {
        height: 0
      },
      200,
      'easeInOutQuad',
      () => {
        $el.removeClass('is-open');
        $fullDescription.attr('style', '');
      }
    );
  }

  function openMore() {
    // Get height of description
    const height = $fullDescription.height();
    // Then collapse it
    $fullDescription.height(0);
    // Then show it
    $el.addClass('is-open');
    isOpen = true;
    // Then animate the height
    $fullDescription.animate(
      {
        height
      },
      300,
      'easeInOutQuad',
      () => {
        // Remove inline styles so things work responsively
        $fullDescription.attr('style', '');
      }
    );
  }

  $moreBtn.click(e => {
    e.preventDefault();
    if (isOpen) {
      closeMore();
    } else {
      openMore();
    }
  });
});
